module.exports = __webpack_public_path__ + "img/modular.253903ad.svg";